<div class="app-store-links">
  <a
    href="https://apps.apple.com/us/app/best-egg/id6476990901"
    target="_blank"
    (click)="fireAppStoreEvent()"
    class="app-store-link"
    aria-label="download on app store"
  >
    <app-icon-apple-store [isDarkMode]="isDarkMode()"></app-icon-apple-store>
  </a>
  <a
    href="https://play.google.com/store/apps/details?id=com.bestegg.app"
    target="_blank"
    (click)="fireGooglePlayEvent()"
    class="google-play-link"
    aria-label="download on google play"
  >
    <app-icon-google-play [isDarkMode]="isDarkMode()"></app-icon-google-play>
  </a>
</div>

<div class="qr-code">
  <img src="assets/images/be-qr-code.png" alt="" width="80" height="60" />
  <p
    class="qr-code-text"
    [ngClass]="isDarkMode() ? 'text-white' : 'text-navy-800'"
  >
    Scan the QR code to download the app on your phone
  </p>
</div>
